function loading () {
    document.getElementById("main-cart-footer").classList.add("loading");
    document.querySelector("cart-items").classList.add("cart-items-is-loading");
    document.querySelectorAll("[data-cart-loader-active]")?.forEach((loading => loading.classList.remove("hidden")));
    document.querySelectorAll("[data-cart-loader-active]")?.forEach((loading => loading.classList.add("grid")));
    document.activeElement.blur();
    document.getElementById("shopping-cart-line-item-status").setAttribute("aria-hidden", false);
}
function deleteFromCart(lineID, cartApi, cartID, cartKey) {
    fetch(`${cartApi}/${cartID}?key=${cartKey}`, {
            method: 'DELETE',
            body: JSON.stringify({
                lines: lineID
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(() => {
            window.location.reload();
        });
}
function deleteGrantCartItem(grantID, e) {
    const stage = window.location.hostname.indexOf('stage');
    const cartCookie = getCookie('cart');
    const cartID = cartCookie.split('%3Fkey%3D').at(0);
    const cartKey = cartCookie.split('%3Fkey%3D').at(-1);
    const cartApi = stage > -1 ? 'https://stage.burnsoft.de/api/shop/cart' : 'https://burnsoft.de/api/shop/cart';

    loading();

    const itemIDs = [];

    (async () => {
        try {
            const response =  await fetch(`${cartApi}/${cartID}?key=${cartKey}`, {
                                method: 'GET',
                                headers: {
                                  'Accept': 'application/json',
                                  'Content-Type': 'application/json'
                                }
                              });
            
            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`);
            }

            const data = await response.json();

            data.contents.forEach(ele => {
                ele.attributes.forEach(attr => {
                    if (attr.value === grantID) {
                        const id = ele.lineId.split('?').at(0);
                        itemIDs.push(id);
                    }
                })
            })

            deleteFromCart(itemIDs, cartApi, cartID, cartKey)
        }
        catch (error) {
    
        console.log('Error:', error);
        }
    })();
}